import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row d-flex  g-4">
          <div className="col-sm-6">
            {/* footer logo section */}
            <div className="footer-content">
              <img src="/image/logo.png" className="img-fluid" alt="" />
              <p className="mt-5 pe-md-5">
                Create, Sell And Collect Truly Rare Digital Artworks. Powered By
                Blockchain Technology.
              </p>
              <div className="mt-md-5 mt-4 footer-icon d-flex gap-md-5 gap-4">
                <i className="fa fa-facebook"></i>
                <i className="fa fa-instagram"></i>
                <i className="fa fa-linkedin"></i>
                <i className="fa fa-twitter"></i>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-sm-6">
            <div className="footer-content">
              <h3 className="mb-5 text-white ">Marketplace</h3>
              <div className="footer-links">
                <ul className="list-unstyled">
                  <li className="mb-3" ><a className="text-decoration-none" href="#">All NFT</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Art</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Music</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Domain Name</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Collections</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Virtual Word</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-sm-6">
            <div className="footer-content">
              <h3 className="mb-5 text-white ">Company</h3>
              <div className="footer-links">
                <ul className="list-unstyled">
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Explore</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">About</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Contact Us</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Blog</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">FAQ</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-sm-6">
            <div className="footer-content">
              <h3 className="mb-5 text-white ">My Account</h3>
              <div className="footer-links">
                <ul className="list-unstyled">
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Author</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Collection</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Author Profile</a></li>
                  <li className="mb-3" ><a className="text-decoration-none" href="#">Create item</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="subfooter text-center py-md-5 py-4 mt-5">
        <p className="mb-0">
        © 2023 Xhibiter — <span>Adnan Tariq</span>
        </p>
      </div>

    </footer>
  );
};

export default Footer;
